import { render } from "./PagePostDetail.vue?vue&type=template&id=12f8bb05"
import script from "./PagePostDetail.vue?vue&type=script&lang=js"
export * from "./PagePostDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__